import { Injectable, OnDestroy } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { AlgoliaQueryOption } from 'src/app/models/algolia-query-option.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { AlgoliaService } from '@app/core/services/algolia.service';
import { resolve } from 'url';

interface QueryConfig {
  path: string; //  path to collection
  field: string; // field to orderBy
  limit?: number; // limit per query
  reverse?: boolean; // reverse order?
  prepend?: boolean; // prepend to source?
}

@Injectable()
export class PaginationService implements OnDestroy {
  // Source data
  private _done = new BehaviorSubject(false);
  private _loading = new BehaviorSubject(false);
  private _data = new BehaviorSubject([]);
  private _noMorePages = new BehaviorSubject(false);

  private algoliaPage = new BehaviorSubject(0);
  private _algoliaData = new BehaviorSubject([]);
  private algoliaTotalPages: number = 0;
  algoliaData: Observable<any[]>;

  private query: QueryConfig;

  // Observable data
  data: Observable<any>;
  storage: Observable<any>;
  done: Observable<boolean> = this._done.asObservable();
  loading: Observable<boolean> = this._loading.asObservable();
  noMorePages: Observable<boolean> = this._noMorePages.asObservable();

  noMoreData = false;
  constructor(private algoliaService: AlgoliaService) {
    this.algoliaData = this._algoliaData.asObservable();
    this.data = this.algoliaData;
  }

  ngOnDestroy() { }

  init() {
    const algoliaQueryOptions: AlgoliaQueryOption = {
      page: this.algoliaPage.value,
      hitsPerPage: 30
    };
    return this.queryAlgolia('', algoliaQueryOptions);
  }

  emitQuery(option: AlgoliaQueryOption) {
    const algoliaQueryOptions: AlgoliaQueryOption = {
      page: this.algoliaPage.value,
      hitsPerPage: 30,
      rentalPriceSort: option.rentalPriceSort,
      priceRange: option.priceRange,
      filters: option.filters
    };
    return this.queryAlgolia('', algoliaQueryOptions, false, true);
  }

  queryAlgolia(query: string, option: AlgoliaQueryOption, append: boolean = false, force = false) {
    const algoliaQueryOptions: AlgoliaQueryOption = option;
    if (!this.noMoreData || force) {
      this._loading.next(true);

      return this.algoliaService.search(query, algoliaQueryOptions)
        .then(data => {
          const { hits, nbPages } = data;
          this.algoliaTotalPages = nbPages - 1;

          if (append) {
            const currentAlgoliaData = this._algoliaData.value;
            this._algoliaData.next([...currentAlgoliaData, ...hits]);
          } else {
            this._algoliaData.next([...hits]);
          }

          if (hits && hits.length <= 0) {
            this._noMorePages.next(true);
            this.noMoreData = true;
          } else {
            this._noMorePages.next(false);
            this.noMoreData = false;
          }

          this._loading.next(false);
          return data;
        });
    } else {
      return new Promise((resl) => resl([]));
    }

  }

  moreAlgolia(query: string = '', option: AlgoliaQueryOption, append = true) {
    let currentPage = this.algoliaPage.value;
    this.algoliaPage.next(++currentPage);

    this.queryAlgolia(query, option, append);
  }

  more(option?: AlgoliaQueryOption, append = true) {
    let algoliaQueryOptions: AlgoliaQueryOption = option != null ? option : {
      page: this.algoliaPage.value,
      hitsPerPage: 30
    };
    this.moreAlgolia('', algoliaQueryOptions, append);
  }

  nukeValues() {
    console.log('destroy');
    this._done = new BehaviorSubject(false);
    this._loading = new BehaviorSubject(false);
    this._data = new BehaviorSubject([]);
  }
}
